// extracted by mini-css-extract-plugin
export default {"metrics":"Metrics_metrics__J3ib0"};